import NavLinkAdapter from '@nexus/core/NavLinkAdapter';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import { makeStyles } from '@material-ui/core/styles';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import { memo, useMemo } from 'react';
import { withRouter } from 'react-router-dom';
import NexusNavBadge from '../../NexusNavBadge';
import { isActive } from '../../navUtils';
import NavIcon from '../../NexusNavIcon';

const useStyles = makeStyles((theme) => ({
  root: {
    minHeight: 48,
    '&.active': {
      backgroundColor: `${theme.palette.secondary.main}!important`,
      color: `${theme.palette.secondary.contrastText}!important`,
      pointerEvents: 'none',
      '& .nexus-list-item-text-primary': {
        color: 'inherit',
      },
      '& .nexus-list-item-icon': {
        color: 'inherit',
      },
    },
    '& .nexus-list-item-icon': {},
    '& .nexus-list-item-text': {
      padding: '0 0 0 16px',
    },
    color: theme.palette.text.primary,
    textDecoration: 'none!important',
  },
}));

function NexusNavHorizontalItem(props) {
  const classes = useStyles(props);
  const { item } = props;

  return useMemo(
    () => (
      <ListItem
        button
        component={NavLinkAdapter}
        to={item.url}
        activeClassName="active"
        isActive={(match, location) => isActive(location, item)}
        className={clsx('nexus-list-item', classes.root)}
        exact={item.exact}
      >
        <NavIcon className="nexus-list-item-icon text-18 flex-shrink-0" icon={item.icon} />

        <ListItemText
          className="nexus-list-item-text"
          primary={item.title}
          classes={{ primary: 'text-16 nexus-list-item-text-primary' }}
        />

        {item.badge && <NexusNavBadge className="ltr:ml-8 rtl:mr-8" badge={item.badge} />}
      </ListItem>
    ),
    [classes.root, item.badge, item.exact, item.icon, item.iconClass, item.title, item.url]
  );
}

NexusNavHorizontalItem.propTypes = {
  item: PropTypes.shape({
    id: PropTypes.string.isRequired,
    title: PropTypes.string,
    icon: PropTypes.string,
    url: PropTypes.string,
  }),
};

NexusNavHorizontalItem.defaultProps = {};

const NavHorizontalItem = withRouter(memo(NexusNavHorizontalItem));

export default NavHorizontalItem;
